import { isMobile, isTablet } from 'react-device-detect';

export const VIEW_SIZE = {
  xLarge: 'xLarge',
  large: 'large',
  medium: 'medium',
  small: 'small',
};

export function getDeviceType() {
  if (isMobile) {
    return 'mobile web';
  }

  if (isTablet) {
    return 'tablet';
  }

  return 'desktop';
}
